import React, {useEffect, useMemo} from 'react';
import {
  useB2BBarcodesReducer,
  useGetBarcodesForExternalCheckout,
} from '../hooks/B2BBarcode';

import {APIV1Version} from '@buncha/common/types/common';
import {B2BBarcodesContext} from '../context/B2BBarcode';
import {B2BScreenParam} from '../types';
import {B2BScreens} from '../navigation/types';
import BarcodeCheckoutList from '../components/BarcodeCheckoutList';
import {Divider} from 'native-base';
import Header from '@buncha/components/composites/Header/Header';
import {Modules} from '@buncha/utils/types';
import ScreenHeader from '@buncha/common/components/screenHeader';
import {StyleSheet} from 'react-native';
import {useAppSelector} from '@buncha/config/redux/hooks';
import {useGetLocale} from '@buncha/localization/hooks';
import {useRoute} from '@react-navigation/native';

const B2BBarcode: React.FC = () => {
  const [state, dispatch] = useB2BBarcodesReducer();
  const provider = useMemo(() => ({state, dispatch}), [dispatch, state]);
  const {getBarcodesForExternalCheckout, loading} =
    useGetBarcodesForExternalCheckout(APIV1Version.V100, dispatch);
  const {title} = useGetLocale(Modules.B2B, B2BScreens.B2BBarcode) ?? {};
  const userInfo = useAppSelector(gState => gState.onboarding.currentUser);
  const routeParams = useRoute()?.params as B2BScreenParam | undefined;
  const runId = routeParams?.runId;
  const userId = userInfo?.id;
  const orderLegacyIds = routeParams?.orderLegacyIds;

  useEffect(() => {
    if (userId && runId)
      getBarcodesForExternalCheckout(userId, runId, orderLegacyIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, runId]);

  return (
    <Header loading={loading} showDefaultLeftHeader>
      <B2BBarcodesContext.Provider value={provider}>
        <ScreenHeader title={title?.scanBarcode} />
        <Divider style={styles.topDivider} />
        <BarcodeCheckoutList />
        <Divider style={styles.buttonStyle} />
      </B2BBarcodesContext.Provider>
    </Header>
  );
};

export default React.memo(B2BBarcode);

const styles = StyleSheet.create({
  topDivider: {marginTop: 5, marginBottom: 20},

  actionButton: {
    marginHorizontal: 10,
    borderRadius: 50,
    marginTop: 20,
  },
  buttonStyle: {marginTop: 10},
});
